import React from 'react';
import {
  PopupDialog,
} from '@revisohq/react-components';
import texts from '../../utils/texts';

export function ErrorDetails(props) {
  const { isOpen, title, onClose, errors } = props;

  return isOpen && <div style={{ textAlign: 'left !important' }}>
    <PopupDialog
      title={title}
      style={{ minWidth: '500px', maxWidth: '800px' }}
      onClose={onClose}
      closeButtonText={texts('CLOSE')}
    >
      <div style={{ textAlign: 'left' }}>
        <ul>
          {errors.map(err => (
            <li key={err.code}>{err.code}: {texts(err.code)}
              {err.messages?.length > 0 && (
                <ul>
                  {err.messages.map((msg, i) => (
                    <li key={i}>{msg}</li>
                  ))}
                </ul>
              )}
            </li>
          ))}
        </ul>
      </div>
    </PopupDialog>
  </div>

}